// Contact information by market
// Update numbers here — all components pull from this file

export const PHONE = {
  wa: "(360) 200-8922",
  waHref: "tel:+13602008922",
  ar: "(501) 232-6644",
  arHref: "tel:+15012326644",
  // Default (main site, non-market pages)
  main: "(360) 200-8922",
  mainHref: "tel:+13602008922",
} as const;

export const EMAIL = {
  main: "team@luminate.media",
  jordan: "jordan@luminate.media",
} as const;

export const getPhoneForState = (stateSlug?: string) => {
  if (stateSlug === "arkansas") {
    return { display: PHONE.ar, href: PHONE.arHref };
  }
  return { display: PHONE.wa, href: PHONE.waHref };
};
